export enum VendorContractType {
    UNSPECIFIED = 'unspecified',
    ELECTRICAL_CHARGING = 'electrical-charging',
    FINANCIAL = 'financial',
    FINANCING_MONTHLY_SERVICE_BUDGET = 'financing-monthly-service-budget',
    FUEL_CARD = 'fuel-card',
    IMPORTER_CARE_SUPPORT = 'importer-care-support',
    INSPECTION = 'inspection',
    INSURANCE = 'insurance',
    MAINTENANCE = 'maintenance',
    PARKING = 'parking',
    SUBSTITUTE_VEHICLE = 'substitute-vehicle',
    TIRE_STORAGE = 'tire-storage',
    TIRE_RENEWAL = 'tire-renewal',
    VEHICLE_DEALERSHIP = 'vehicle-dealership',
    VEHICLE_TAX = 'vehicle-tax',
    VEHICLE_TRACKING = 'vehicle-tracking',
    WASHING = 'washing',
}
